import { Action } from '@ngrx/store';
import {
  InputTotSelect,
  InitInputTotSelect,
  TotSelect,
  Scommessa,
  Sistema,
} from 'src/app/models/totselect.interface';
import { IStateCart } from 'src/app/models/statecart.interface';

export enum ETotSelectActions {
  InitTotSelect = '[InitTotSelect] Init TotSelect',
  AddTotSelect = '[AddTotSelect] Add TotSelect',
  DelTotSelect = '[DelTotSelect] Del TotSelect',
  ResetMapsTotSelect = '[ResetMapsTotSelect] Reset Maps Totselect',
  UpdateTotCombination = '[UpdateTotComination] Update TotCombination',
  UpdateMulti = '[UpdateMutli] Update Multi',
  ResetTotSystem = '[ResetTotSystem] Reset TotSystem',
  ResetTotSco = '[ResetTotSco] Reset TotSco',
  AddSessionTot = '[AddSessionTot] Add Session to Tot',
  PlaceScoTot = '[PlaceBetTot] Place Bet Tot',
  SelectSco = '[SelectSco] Select Scommessa Tot',
  SelectSystem = '[SelectSystem] Select Sistema Tot',
  Add = '[Add] Add Select Tot',
  AddScoTot = '[AddScoTot] Add Scommessa Tot',
  RemoveScoTot = '[RemoveScoTot] Remove Scommessa Tot',
  AddScoPsr = '[AddScoPsr] Add Scommessa Psr',
  RemoveScoPsr = '[RemoveScoPsr] Remove Scommessa Psr',
  ResetScoTotPsr = '[ResetScoTotPsr] Reset Scommessa Tot&Psr',
  PlaceScoTotQuick = '[PlaceScoTotQuick] Place Sco Tot Quick',
  ResetScoQuick = '[ResetScoQuick] Reset Scommessa Quick',
  UpdateScoTotQuick = '[UpdateScoTotQuick] Update State Tot Quick',
}

export class InitTotSelect implements Action {
  public readonly type = ETotSelectActions.InitTotSelect;
  constructor(public payload: InitInputTotSelect) {}
}

export class AddTotSelect implements Action {
  public readonly type = ETotSelectActions.AddTotSelect;
  constructor(public payload: InputTotSelect) {}
}

export class DelTotSelect implements Action {
  public readonly type = ETotSelectActions.DelTotSelect;
  constructor(public payload: InputTotSelect) {}
}

export class ResetMapsTotSelect implements Action {
  public readonly type = ETotSelectActions.ResetMapsTotSelect;
  constructor() {}
}

export class UpdateTotCombination implements Action {
  public readonly type = ETotSelectActions.UpdateTotCombination;
  constructor(public payload: number) {}
}

export class UpdateMulti implements Action {
  public readonly type = ETotSelectActions.UpdateMulti;
  constructor(public payload: number) {}
}

export class Add implements Action {
  public readonly type = ETotSelectActions.Add;
  constructor(public payload: TotSelect) {}
}

export class ResetTotSystem implements Action {
  public readonly type = ETotSelectActions.ResetTotSystem;
  constructor() {}
}

export class ResetTotSco implements Action {
  public readonly type = ETotSelectActions.ResetTotSco;
  constructor() {}
}

export class AddSessionTot implements Action {
  public readonly type = ETotSelectActions.AddSessionTot;
  constructor(public payload: string) {}
}

export class SelectSco implements Action {
  public readonly type = ETotSelectActions.SelectSco;
  constructor(public payload: Scommessa) {}
}

export class SelectSystem implements Action {
  public readonly type = ETotSelectActions.SelectSystem;
  constructor(public payload: Sistema) {}
}

export class PlaceScoTot implements Action {
  public readonly type = ETotSelectActions.PlaceScoTot;
  constructor(public payload: TotSelect) {}
}

export class AddScoTot implements Action {
  public readonly type = ETotSelectActions.AddScoTot;
  constructor() {}
}

export class RemoveScoTot implements Action {
  public readonly type = ETotSelectActions.RemoveScoTot;
  constructor(public payload: number) {}
}

export class AddScoPsr implements Action {
  public readonly type = ETotSelectActions.AddScoPsr;
  constructor() {}
}

export class RemoveScoPsr implements Action {
  public readonly type = ETotSelectActions.RemoveScoPsr;
  constructor(public payload: number) {}
}

export class ResetScoTotPsr implements Action {
  public readonly type = ETotSelectActions.ResetScoTotPsr;
  constructor() {}
}

export class PlaceScoTotQuick implements Action {
  public readonly type = ETotSelectActions.PlaceScoTotQuick;
  constructor(public payload: any) {}
}

export class UpdateScoTotQuick implements Action {
  public readonly type = ETotSelectActions.UpdateScoTotQuick;
  constructor(public payload: IStateCart) {}
}

export type TotSelectActions =
  | InitTotSelect
  | AddTotSelect
  | DelTotSelect
  | ResetMapsTotSelect
  | ResetTotSystem
  | ResetTotSco
  | SelectSco
  | SelectSystem
  | UpdateTotCombination
  | UpdateMulti
  | AddSessionTot
  | PlaceScoTot
  | AddScoTot
  | RemoveScoTot
  | AddScoPsr
  | RemoveScoPsr
  | ResetScoTotPsr
  | Add
  | PlaceScoTotQuick
  | UpdateScoTotQuick;
